.phoneInputOverlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.phoneInputOverlayFullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--vkui--color_background_content);
  padding: 0;
}

@media (width >= 769px) {
  .phoneInputOverlay,
  .phoneInputOverlayTablet {
    height: calc(100% - 45px);
    background-color: rgb(0 0 0 / 40%);
  }

  .phoneInputOverlay .phoneInputContainer,
  .phoneInputOverlayTablet .phoneInputContainer {
    margin-top: -16%;
  }
}

.phoneInputContainer {
  background: var(--vkui--color_background_content);
  border-radius: 12px;
  width: calc(100% - 32px);
  max-width: 400px;
  box-shadow: var(--vkui--elevation3);
  position: relative;
}

.phoneInputContainerFullscreen {
  width: 100%;
  max-width: 100%;
  height: 100%;
  border-radius: 0;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  overflow-y: auto;
  box-sizing: border-box;
}

.phoneInputContainerTablet {
  max-width: 500px;
}

.phoneInputHeader {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 4px;
}

.backButton {
  background: none;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--vkui--color_icon_accent);
}

.backButton:focus-visible {
  outline: 2px solid var(--vkui--color_stroke_accent);
  outline-offset: 2px;
  border-radius: 4px;
}

.phoneInputTitle {
  flex: 1;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2px;
}

.subtitle {
  color: var(--vkui--color_text_secondary);
  font-size: 14px;
}

.inputWrapper {
  padding: 24px 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.buttonContainer {
  padding: 17px 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
}

@media (width <= 768px) {
  .phoneInputHeader {
    position: relative;
  }

  .subtitle {
    font-size: 16px;
  }

  .inputWrapper {
    flex: 0;
  }

  .buttonContainer {
    padding: 0;
    flex-direction: column;
    gap: 0;
    height: 44px;
  }

  .buttonContainer > :not(:last-child) {
    margin-bottom: 12px;
  }
}
